import React from 'react';

import Tabs from '../../Tabs/Tabs';
import { TradingEventsListState } from './TradingEventsList.state';
import { observer } from 'src/utils/mobx-react';

interface PropsType {
    tradingEventsListState: TradingEventsListState;
}

export const TradingEventsListTopHeader = observer(
    'TradingEventsListTopHeader',
    (props: PropsType): React.ReactElement => {
        const { tradingEventsListState } = props;
        const tab = tradingEventsListState.tab;

        return (
            <div className='trading-events-list-options'>
                <a
                    href='#'
                    className='btn btn-add'
                    onClick={tradingEventsListState.onAddEvent}
                >
                    Create event
                </a>
                <Tabs
                    className='tabs__vertical'
                    active={tab}
                    onChange={tradingEventsListState.changeTab}
                >
                    <span
                        key='details'
                        //@ts-expect-error
                        label='Details'
                    />
                    <span
                        key='prices'
                        //@ts-expect-error
                        label='Prices'
                    />
                </Tabs>
            </div>
        );
    }
);
